import {SET_LABELS} from "../../constants";

const initialState = {
    labels: []
}
export const LabelsReducer = (state = initialState, action) => {
    switch (action.type){
        case SET_LABELS:
            return {
                ...state,
                labels: action.payload
            }
        default:
            return state
    }
}